import React from 'react';
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import sttLogoWhite from '../assets/images/stt-logo-white.png';

const Home: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        // Occupy the viewport minus navbar
        minHeight: 'calc(100vh - 64px)',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        // The global style or body handles overflowX: 'hidden'
      }}
    >
      <Box
        component="img"
        src={sttLogoWhite}
        alt="STT Logo"
        sx={{
          // let the image resize gracefully
          maxWidth: isMobile ? '80%' : '40%',
          height: 'auto',
          objectFit: 'contain',
          display: 'block',
        }}
      />

      <Typography
        variant={isMobile ? 'h5' : 'h4'}
        sx={{ mt: 2, textAlign: 'center', color: theme.palette.grey[800] }}
      >
        A metal-driven 5 piece out of Charlotte, NC.
      </Typography>
    </Box>
  );
};

export default Home;
